import { DESTINATION_TYPES } from '../../../containers/destination/constants/destinationTypes';
import { SchemaRelation, SchemaRelationTypeGroup } from '../interfaces/schemaRelations';
import { HevoEntity } from '../../../core/interfaces/hevo-entity';
import { SOURCE_TYPES } from '../../../containers/pipeline/interfaces/source-type';

export function SchemaRelationTypeGroupsFactory(rawData: any[]): SchemaRelationTypeGroup[] {
  const groups = (rawData || []).reduce((dict: { [key: string]: SchemaRelationTypeGroup }, relationRawData) => {
    const relation = SchemaRelationFactory(relationRawData);

    if (!dict[relation.meta.type]) {
      dict[relation.meta.type] = {
        meta: relation.meta,
        relationNames: []
      };
    }

    dict[relation.meta.type].relationNames.push(relation.name);

    return dict;
  }, {});

  return Object.values(groups);
}

export function SchemaRelationFactory(rawData): SchemaRelation {
  switch (rawData.entity_type) {
    case HevoEntity.MODEL.value:
      return ModelSchemaRelationFactory(rawData);
    case HevoEntity.PIPELINE.value:
      return PipelineSchemaRelationFactory(rawData);
    default:
      return ActivationTargetRelationFactory(rawData);
  }
}

export function ModelSchemaRelationFactory(rawData) {
  return {
    name: rawData.entity.name,
    meta: {
      iconName: 'models',
      type: HevoEntity.MODEL.value,
      typeDisplay: HevoEntity.MODEL.name
    }
  };
}

export function PipelineSchemaRelationFactory(rawData) {
  return {
    name: rawData.entity.source_name,
    meta: {
      type: rawData.entity.source_type,
      typeDisplay: rawData.entity.source_type_display,
      logoUrl: rawData.entity.source_type_logo_url,
      darkModeLogoUrl: rawData.entity.source_type_dark_mode_logo_url,
      logoPrimaryColor: SOURCE_TYPES[rawData.entity.source_type]?.primaryColor,
      darkModePrimaryColor: SOURCE_TYPES[rawData.entity.source_type]?.darkModePrimaryColor
    }
  };
}

export function ActivationTargetRelationFactory(rawData) {
  return {
    name: rawData.name,
    meta: {
      type: rawData.type,
      typeDisplay: rawData.type,
      logoUrl: rawData.logoUrl,
      darkModeLogoUrl: rawData.logoUrl,
      logoPrimaryColor: DESTINATION_TYPES[rawData.type].primaryColor,
      darkModePrimaryColor: DESTINATION_TYPES[rawData.type].darkModePrimaryColor
    }
  }
}
